import { render } from "./InvoiceAmountsForm.vue?vue&type=template&id=8b21017c&ts=true"
import script from "./InvoiceAmountsForm.vue?vue&type=script&lang=ts"
export * from "./InvoiceAmountsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__